import moment from 'moment';
import { isRobotE2E } from '../utils/e2eBotUtils';
import { getExperimentVariationIds } from './analytics';

export function gtmEvent({ action, withTimeout = false, ...otherAttributes } = {}) {
  if (withTimeout) {
    setTimeout(() => {
      pushToDatalayerWrap({ action, ...otherAttributes });
    }, 0);
  } else {
    pushToDatalayerWrap({ action, ...otherAttributes });
  }
}

function pushToDatalayerWrap({ action, ...otherAttributes } = {}) {
  pushToDatalayer(
    'event',
    action,
    getAllAttributes(otherAttributes)
  );
}

function pushToDatalayer() {
  const win = window || {};
  const dl = win.dataLayer;
  if (dl) dl.push(arguments);
}

function getAllAttributes({ componentProps = {}, pageName, ...otherAttributes } = {}) {
  const allAttributes = {
    app_name: 'web-site',
    timestamp: moment().unix(),
    is_e2e_bot: isRobotE2E(),
    ...otherAttributes,
  };
  let experimentVariantIds = getExperimentVariationIds();
  if (experimentVariantIds) {
    experimentVariantIds = experimentVariantIds.reduce((acc, curr, i) => {
      const comb = acc + curr.id + '-' + curr.variant;
      if (i === experimentVariantIds.length - 1) return comb;
      return comb + ';';
    }, '');
  } else {
    experimentVariantIds = '';
  }
  allAttributes.unleash_ab_test_ids = experimentVariantIds;
  if (pageName) allAttributes.screen_name = pageName;
  if (componentProps.response) allAttributes.pageUrl = componentProps.response.location.pathname;
  if (componentProps.deviceInfo) {
    allAttributes.deviceType = componentProps.deviceInfo.device;
    allAttributes.deviceOS = componentProps.deviceInfo.browser.os;
  }
  return allAttributes;
}

export function gtmPageviewEvent({ withTimeout = true, ...otherAttributes } = {}) {
  gtmEvent({
    action: 'screen_view',
    withTimeout,
    ...otherAttributes,
  });
}

export function gtmCtaTapEvent(otherAttributes = {}) {
  gtmEvent({
    action: 'cta_tapped',
    ...otherAttributes,
  });
}



// WEBPACK FOOTER //
// ./src/services/google-tag-manager.js